// Theme colours
const themeColors = {
  alterraYellow: '#e68c19',
  alterraOrange: '#e66519',
  alterraRed: '#d2191e',
  alterraDarkBlue: '#0A0F26',
};

// Background colours
const backgroundColors = {
  backgroundLight: '#f5f5f5',
  backgroundDark: '#0A0F26',
  backgroundSecondary: '#ffffff',
  backgroundTertiary: '#e66519',
};

// Theme variant colours
const themeVariantColors = {
  themeLightMain: '#181717',
  themeLightInverse: '#ffffff',
  themeLightBackground: '#f5f5f5',
  themeDarkMain: '#ffffff',
  themeDarkInverse: '#000000',
  themeDarkBackground: '#0a0f26',
  themeSecondaryMain: '#000000',
  themeSecondaryInverse: '#ffffff',
  themeSecondaryBackground: '#ffffff',
  themeTertiaryMain: '#ffffff',
  themeTertiaryInverse: '#000000',
  themeTertiaryBackground: '#e66519',
};

// Core colours override
const coreColors = {
  headingsText: '#d2191e',
  bodyText: '#000000',
  footerText: '#ffffff',
  footerSubText: '#ffffff',
  overlayText: '#ffffff',
  linkText: '#e66519',
  linkHover: '#d2191e',
  buttonBorder: themeColors.alterraOrange,
  buttonBackground: themeColors.alterraOrange,
  buttonText: '#ffffff',
  buttonBorderHover: themeColors.alterraRed,
  buttonBackgroundHover: themeColors.alterraRed,
  buttonTextHover: '#ffffff',
  buttonAltBorder: themeColors.alterraRed,
  buttonAltBackground: themeColors.alterraRed,
  buttonAltText: '#ffffff',
  buttonAltBorderHover: themeColors.alterraOrange,
  buttonAltBackgroundHover: themeColors.alterraOrange,
  buttonAltTextHover: '#ffffff',
  interactiveBorder: '#e66519',
  interactiveBackground: '#e66519',
  interactiveText: '#ffffff',
  interactiveBorderHover: '#d2191e',
  interactiveBackgroundHover: '#d2191e',
  interactiveTextHover: '#ffffff',
  navigationLinkText: '#ffffff',
  navigationLinkHover: '#e66519',
  footerLinkText: '#ffffff',
  footerLinkHover: '#e66519',
  headerBackground: '#000000',
  bodyBackground: '#ffffff',
  footerBackground: '#0a0f26',
  footerSubBackground: '#0a0f26',
  formInputBorder: '#17235b',
  formInputBorderError: '#d2191e',
  formInputBackground: '#ffffff',
  formInputText: '#000000',
  formErrorText: '#d2191e',
  itemBorder: '#17235b',
  dropShadow: 'rgba(23, 35, 91, 0.01)',
  loadingIndicator: '#e66519',
  socialIcon: '#ffffff',
  black: '#000000',
  white: '#ffffff',
  themeMain: '#ffffff',
  themeInverse: '#000000',
  themeBackground: '#ffffff',
  headingsTextDark: '#ffffff',
  bodyTextDark: '#ffffff',
  footerTextDark: '#ffffff',
  footerSubTextDark: '#ffffff',
  overlayTextDark: '#ffffff',
  linkTextDark: '#ffffff',
  linkHoverDark: '#e1e1e1',
  buttonBorderDark: '#000000',
  buttonBackgroundDark: '#ffffff',
  buttonTextDark: '#000000',
  buttonBorderHoverDark: '#000000',
  buttonBackgroundHoverDark: '#f5f3f5',
  buttonTextHoverDark: '#000000',
  buttonAltBorderDark: '#ffffff',
  buttonAltBackgroundDark: 'rgba(255, 255, 255, 0)',
  buttonAltTextDark: '#000000',
  buttonAltBorderHoverDark: '#ffffff',
  buttonAltBackgroundHoverDark: '#f5f3f5',
  buttonAltTextHoverDark: '#000000',
  interactiveBorderDark: '#000000',
  interactiveBackgroundDark: '#000000',
  interactiveTextDark: '#ffffff',
  interactiveBorderHoverDark: '#1d1f22',
  interactiveBackgroundHoverDark: '#1d1f22',
  interactiveTextHoverDark: '#efefef',
  navigationLinkTextDark: '#ffffff',
  navigationLinkHoverDark: '#f5f3f5',
  footerLinkTextDark: '#ffffff',
  footerLinkHoverDark: '#f5f3f5',
  headerBackgroundDark: '#000000',
  bodyBackgroundDark: '#1d1f22',
  footerBackgroundDark: '#000000',
  footerSubBackgroundDark: '#000000',
  formInputBorderDark: '#000000',
  formInputBorderErrorDark: '#F43319',
  formInputBackgroundDark: '#ffffff',
  formInputTextDark: '#000000',
  formErrorTextDark: '#F43319',
  itemBorderDark: '#000000',
  dropShadowDark: 'rgba(255, 255, 255, 0)',
  loadingIndicatorDark: '#ffffff',
  socialIconDark: '#ffffff',
};

// Override font sizes as required
const themeFontSizes = {
  '7xl': [
    '82px',
    {
      lineHeight: '88px',
      letterSpacing: '0',
      fontWeight: '500',
    },
  ],
  '6xl': [
    '72px',
    {
      lineHeight: '78px',
      letterSpacing: '0',
      fontWeight: '500',
    },
  ],
  '5xl': [
    '62px',
    {
      lineHeight: '68px',
      letterSpacing: '0',
      fontWeight: '500',
    },
  ],
  '4xl': [
    '64px',
    {
      lineHeight: '70px',
      letterSpacing: '0',
      fontWeight: '500',
    },
  ],
  '3xl': [
    '45px',
    {
      lineHeight: '55px',
      letterSpacing: '0',
      fontWeight: '700',
    },
  ],
  '2xl': [
    '36px',
    {
      lineHeight: '44px',
      letterSpacing: '0',
      fontWeight: '500',
    },
  ],
  xl: [
    '36px',
    {
      lineHeight: '44px',
      letterSpacing: '0',
      fontWeight: '400',
    },
  ],
  lg: [
    '32px',
    {
      lineHeight: '40px',
      letterSpacing: '0',
      fontWeight: '400',
    },
  ],
  md: [
    '30px',
    {
      lineHeight: '36px',
      letterSpacing: '0',
      fontWeight: '400',
    },
  ],
  base: [
    '28px',
    {
      lineHeight: '32px',
      letterSpacing: '0',
      fontWeight: '400',
    },
  ],
  sm: [
    '18px',
    {
      lineHeight: '22px',
      letterSpacing: '0',
      fontWeight: '300',
    },
  ],
  xs: [
    '14px',
    {
      lineHeight: '20px',
      letterSpacing: '0',
      fontWeight: '300',
    },
  ],
};

// Theme classes for custom styling
const themeVariants = [];

const fontFamily = {
  primary: ['Dubai Regular', 'sans-serif'],
  secondary: ['Dubai Regular', 'sans-serif'],
};

const spacing = {
  'vertical-nav': '200px',
  'header-height': '150px',
  'header-height-scrolled': '90px',
  'mobile-header-height': '60px',
};

module.exports = {
  themeColors,
  backgroundColors,
  themeVariantColors,
  coreColors,
  themeVariants,
  fontFamily,
  themeFontSizes,
  spacing,
};
